import React from 'react';
import { IonContent, IonPage, IonHeader, IonToolbar, IonTitle } from '@ionic/react';

interface PaymentPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

const PaymentPageLayout: React.FC<PaymentPageLayoutProps> = ({ title, children }) => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {children}
      </IonContent>
    </IonPage>
  );
};

export default PaymentPageLayout;